import React, { useEffect, useState } from "react";
import "./Homepage.css";
import axios from "axios";
import DeleteDuplicatesButton from "./button";
import { db } from "../Firebase";
import { getDocs, collection } from "firebase/firestore";

// const rareDrugs = [
//   { id: 1, name: "Zolgensma", use: "Spinal Muscular Atrophy" },
//   { id: 2, name: "Luxturna", use: "Inherited Retinal Disease" },
//   { id: 3, name: "Spinraza", use: "Neuromuscular Disorder" },
//   { id: 4, name: "Soliris", use: "Rare Blood Disorder" },
// ];

export default function Home() {

const [rareDrugs, setrareDrugs] = useState([]);  



  const handleChange = async (e) => {
  const query = e.target.value;


axios({
  method: 'get',
  url: 'http://localhost:8000/collections',
  headers: {
    'Content-Type': 'application/json',
  },
  data: {
    name: 'starwars',
    age: 25
  }
})
.then(response => {
  console.log('Response:', response.data);
})
.catch(error => {
  console.error('Error:', error);
});
 };

const handleEdit = (id, field, value) => {
  setrareDrugs((prevDrugs) =>
    prevDrugs.map((drug) =>
      drug.id === id
        ? { ...drug, [field]: value }
        : drug
    )
  );
};

const recordlookup = async (id, name) => {

  try {

    const response = await fetch("https://backend.zenithcbe.com/" , {
    
      method: "Post",
      headers: {
        "Content-Type": "application/json", 
      },

      body: JSON.stringify({

       id,
       name

      })

    }
   
  )

  } catch{}

}


const deleteDuplicates = async () => {
  try{ 
     await fetch("https://backend.zenithcbe.com/deleteDuplicates", {
      method: "delete",
      headers: {
        "Content-Type": "application/json"
      },     
    }

    ) 
  }
  catch(error){

    console.error("This is the error:", error)
  }
}

const requestAccess = async (drug) => {
  try {
    const response = await fetch("https://backend.zenithcbe.com/api/request-drug", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        drugId: drug.id,
        drugName: drug.name,
        drugUse: drug.use,
      }),
    });

    const data = await response.json();

    console.log("Saved:", data);

    alert("Drug request submitted");
  } catch (error) {
    console.error("Error:", error);
  }
};

useEffect(() => {
  const fetchDrugs = async () => {
    try {
      const querySnapshot = await getDocs(
        collection(db, "drugRequests")
      );

      const drugs = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

     setrareDrugs(drugs);
     console.log(drugs)
    } catch (error) {
      console.log(error);
    }
  };

  fetchDrugs();
}, []);


  return (
    <div className="phama">
      {/* Hero */}
      <section className="hero">
        <h1>Access Rare & Life-Saving Medicines</h1>
        <p>Trusted platform for specialty and orphan drugs worldwide.</p>

      <input
  type="text"
  placeholder="Search rare drugs..."
  className="search"
  onChange= {handleChange}

/>
    <DeleteDuplicatesButton
    onClick={deleteDuplicates}
    />
  
      </section>

{/* Rare Drugs */}
<section
  style={{
    padding: "60px 20px",
    background: "#f4f7fb",
  }}
>
  <h2
    style={{
      textAlign: "center",
      fontSize: "2rem",
      marginBottom: "40px",
      color: "#1e293b",
      fontWeight: "700",
    }}
  >
    Rare Drugs
  </h2>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
      gap: "24px",
    }}
  >
    {rareDrugs.map((drug) => (
      <div
        key={drug.id}
        style={{
          background: "#fff",
          borderRadius: "18px",
          padding: "24px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          transition: "0.3s ease",
        }}
      >
        <input
          type="text"
          value={drug.drugName}
          onChange={(e) =>
            handleEdit(
              drug.id,
              "drugName",
              e.target.value
            )     
          }
          style={{
            padding: "14px",
            borderRadius: "12px",
            border: "1px solid #dbeafe",
            fontSize: "1.1rem",
            fontWeight: "600",
            outline: "none",
            background: "#f8fafc",
          }}
        />

        <textarea
          value={drug.drugUse}
          onChange={(e) =>
            handleEdit(
              drug.id,
              "drugUse",
              e.target.value
            )
          }
          rows={4}
          style={{
            padding: "14px",
            borderRadius: "12px",
            border: "1px solid #dbeafe",
            fontSize: "1rem",
            resize: "none",
            outline: "none",
            background: "#f8fafc",
            lineHeight: "1.5",
          }}
        />

        <button
          onClick={() => requestAccess(drug)}
          style={{
            padding: "14px",
            border: "none",
            borderRadius: "12px",
            background:
              "linear-gradient(135deg, #2563eb, #1d4ed8)",
            color: "white",
            fontSize: "1rem",
            fontWeight: "600",
            cursor: "pointer",
            transition: "0.3s ease",
            boxShadow: "0 4px 12px rgba(37,99,235,0.3)",
          }}
        >
          Request Access
        </button>
      </div>
    ))}
  </div>
</section>

      {/* Services */}
      <section className="section light">
        <h2>Services</h2>
        <div className="services">
          <div>📄 Prescription Verification</div>
          <div>🚚 Secure Delivery</div>
          <div>👨‍⚕️ Expert Support</div>
          <div>🌍 Global Supply</div>
        </div>
      </section>
    </div>
  );
}